import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const [countdown, setCountdown] = useState(5); // Imposta il countdown iniziale a 5 secondi
  const navigate = useNavigate();

  useEffect(() => {
    // Imposta un intervallo che diminuisce il countdown ogni secondo
    const countdownInterval = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    // Quando il countdown arriva a 0, esegue il reindirizzamento
    if (countdown === 0) {
      navigate("/home");
    }

    // Pulizia: quando il componente si smonta o il countdown arriva a 0, pulisci l'intervallo
    return () => clearInterval(countdownInterval);
  }, [countdown, navigate]);

  return (
    <div className="container mx-auto mt-4">
      <div
        className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
        role="alert"
      >
        <span>Non sei autorizzato ad accedere a questa pagina</span>
        {countdown > 0 && (
          <span>{` Verrai reindirizzato tra ${countdown} secondi...`}</span>
        )}
      </div>
    </div>
  );
};

export default Unauthorized;
